import {useState} from "react"
import arrayUtilities from "../../utilities/arrayUtilities"
import {toDateString} from "../../utilities/dateUtilities"
import {Modal} from "react-bootstrap"
import {Link} from "react-router-dom/cjs/react-router-dom.min"
import {renderValidity} from "../../utilities/allowListUtilities";
import api from "../api/api";
import {ErrorModal} from "../../utilities/errorModal";
import stringHelpers from "../../utilities/stringHelpers";

export const SiteAnprSettingsTable = ({variableAnprRows, siteId, site, clientId, organisationId, canUpdate, token, refresh, isNewSite}) => {
    const [anprRangeModal, setAnprRangeModal] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    return (
        <>
            <table
                className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer site-anpr-settings-table">
                <thead className="bg-200 text-900">
                <tr>
                    <th>Name</th>
                    <th>Enabled</th>
                    <th>Date Range</th>
                    <th>Validity</th>
                    <th>Over Stay</th>
                    <th>Not on Allow List</th>
                    <th>Short Return</th>
                    <th>Pay and Display</th>
                    {canUpdate && <th>&nbsp;</th>}
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td><Link
                        to={`/organisation/${organisationId}/client/${clientId}/site/${siteId}/anpr-settings/standard-anpr`}>
                        <h6 className="mb-0">Standard ANPR</h6>
                    </Link></td>
                    <td>
                        {site.isAnprEnabled && <i className="fas fa-check text-success"></i>}
                        {!site.isAnprEnabled && <i className="fas fa-times text-danger"></i>}
                    </td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>{stringHelpers.isNullOrEmpty(site.overstayContraventionId) &&
                        <i className="fas fa-times text-danger"></i>}
                        {!stringHelpers.isNullOrEmpty(site.overstayContraventionId) &&
                            <i className="fas fa-check text-success"></i>}
                    </td>
                    <td>{stringHelpers.isNullOrEmpty(site.notOnAllowListContraventionId) &&
                        <i className="fas fa-times text-danger"></i>}
                        {!stringHelpers.isNullOrEmpty(site.notOnAllowListContraventionId) &&
                            <i className="fas fa-check text-success"></i>}
                    </td>
                    <td>{stringHelpers.isNullOrEmpty(site.shortReturnContraventionId) &&
                        <i className="fas fa-times text-danger"></i>}
                        {!stringHelpers.isNullOrEmpty(site.shortReturnContraventionId) &&
                            <i className="fas fa-check text-success"></i>}
                    </td>
                    <td>{!site.isPayAndDisplayEnabled &&
                        <i className="fas fa-times text-danger"></i>} {site.isPayAndDisplayEnabled &&
                        <i className="fas fa-check text-success"></i>}
                    </td>
                </tr>
                {
                    !arrayUtilities.isNullOrEmpty(variableAnprRows)
                    && variableAnprRows.map((range) =>
                        <tr key={range.id}>
                            <td className="name-cell">
                                <Link
                                    to={`/organisation/${organisationId}/client/${clientId}/site/${siteId}/anpr-settings/${range.id}`}>
                                    <h6 className="mb-0 text-ellipsis">{stringHelpers.isNullOrEmpty(range.name) ? "Variable ANPR" : range.name}</h6>
                                </Link>
                            </td>
                            <td>{!range.isEnabled && <i className="fas fa-times text-danger"></i>} {range.isEnabled &&
                                <i className="fas fa-check text-success"></i>}</td>
                            <td>{toDateString(range.startDate)} &mdash; {toDateString(range.endDate)}</td>
                            <td>{renderValidity(range)}</td>
                            <td>{stringHelpers.isNullOrEmpty(range.overstayContraventionId) && <i className="fas fa-times text-danger"></i>}
                                {!stringHelpers.isNullOrEmpty(range.overstayContraventionId) && <i className="fas fa-check text-success"></i>}
                            </td>
                            <td>N/A</td>
                            <td>{stringHelpers.isNullOrEmpty(range.shortReturnContraventionId) && <i className="fas fa-times text-danger"></i>}
                                {!stringHelpers.isNullOrEmpty(range.shortReturnContraventionId) && <i className="fas fa-check text-success"></i>}
                            </td>
                            <td>{!range.isPayAndDisplayEnabled &&
                                <i className="fas fa-times text-danger"></i>} {range.isPayAndDisplayEnabled &&
                                <i className="fas fa-check text-success"></i>}
                            </td>
                            {canUpdate && <td className="text-right">
                                <button onClick={() => setAnprRangeModal(range)} className="btn btn-non p-0 m-0"
                                        type="button"><i className="far fa-trash-alt"></i></button>
                            </td>}
                        </tr>)
                }
                </tbody>
            </table>
            {
                anprRangeModal &&
                <Modal show centered size="md" onHide={() => setAnprRangeModal(null)}>
                    <Modal.Header>
                        <Modal.Title>Delete ANPR Setting</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete the Variable ANPR Setting <b>{anprRangeModal.name}</b>?
                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick={() => setAnprRangeModal(null)} className="btn btn-outline-secondary"
                                type="button">Cancel
                        </button>
                        <button onClick={() => {
                            api.deleteSiteVariableAnprRange(
                                data => {
                                    if (data.isError) {
                                        setErrorMessage(data.errorMessage)
                                    } else {
                                        setErrorMessage(null)
                                        refresh()
                                    }
                                    setAnprRangeModal(null)
                                },
                                error => {
                                    if (!stringHelpers.isNullOrEmpty(error?.errorMessage)) {
                                        setErrorMessage(error.errorMessage)
                                    }
                                    refresh()
                                    setAnprRangeModal(null)
                                },
                                siteId, anprRangeModal.id,
                                organisationId, token
                            )
                        }} className="btn btn-danger" type="button">Delete
                        </button>
                    </Modal.Footer>
                </Modal>
            }
            {
                !stringHelpers.isNullOrEmpty(errorMessage)
                && <ErrorModal onHide={() => setErrorMessage(null)} message={errorMessage}/>
            }
        </>
    )
}